export enum ServicioCodigoEnum {
  ECOT101 = 'ECOT101',
  ECOT102 = 'ECOT102',
  ECOT103 = 'ECOT103',
  ECOT104 = 'ECOT104',
  ECOTGEN = 'ECOTGEN',
  NIVRENTI = 'NIVRENTI',
  SVDCTITWS02 = 'SVDCTITWS02',
  SVDCDYGWS02 = 'SVDCDYGWS02',
  SVDCBIWS02 = 'SVDCBIWS02',
  SVDCDATWS02 = 'SVDCDATWS02',
  SVDCCSVWS01 = 'SVDCCSVWS01',
  SVDCATASTROVDRWS01 = 'SVDCATASTROVDRWS01',
  SVDCATASTROCERTIFICADOVDRWS01 = 'SVDCATASTROCERTIFICADOVDRWS01',
  SVDCCAACPASWS01 = 'SVDCCAACPASWS01',
  SVDCCAACPCWS01 = 'SVDCCAACPCWS01',
  SVDSCTFNWS01 = 'SVDSCTFNWS01',
  SVDSCDDWS01 = 'SVDSCDDWS01',
  SVDCCAADISCAPACIDADWS01 = 'SVDCCAADISCAPACIDADWS01',
  SVDPERMEXWS01 = 'SVDPERMEXWS01',
  SVDSMATESCOLARIZAWS01 = 'SVDSMATESCOLARIZAWS01',
  SVDCCAAIRPHWS01 = 'SVDCCAAIRPHWS01',
  SVDSRSPSBACTUALWS01 = 'SVDSRSPSBACTUALWS01',
  SVDSRSPSBANUALWS01 = 'SVDSRSPSBANUALWS01',
  SVDSCDDESTACWS01 = 'SVDSCDDESTACWS01',
  SVDCCAADISCAPACIDADESTACRD888WS01 = 'SVDCCAADISCAPACIDADESTACRD888WS01',
  SVDAPTNACIWS01 = 'SVDAPTNACIWS01',
  SVDCGCOMDATOSPUBLICOSWS01 = 'SVDCGCOMDATOSPUBLICOSWS01',
  SVDCGCOMHABILITADOWS01 = 'SVDCGCOMHABILITADOWS01',
  SVDNOTCOPSIMWS01 = 'SVDNOTCOPSIMWS01',
  SVDNOTLISTWS01 = 'SVDNOTLISTWS01',
  SVDNOTSUBWS01 = 'SVDNOTSUBWS01',
  SVDNOTSUBADMWS01 = 'SVDNOTSUBADMWS01',
  SVDNOTCESIONCREDITOWS01 = 'SVDNOTCESIONCREDITOWS01',
  SVDREGPUBCONWS01 = 'SVDREGPUBCONWS01',
  SVDCORPMEVIGENCIACARGOWS01 = 'SVDCORPMEVIGENCIACARGOWS01',
  SVDCORPMESUCESIONEMPRESASWS01 = 'SVDCORPMESUCESIONEMPRESASWS01',
  SVDMATUNIVWS01 = 'SVDMATUNIVWS01',
  SVDCRUEACCESOUNIVWS01 = 'SVDCRUEACCESOUNIVWS01',
  SVDCSDBECASDANWS01 = 'SVDCSDBECASDANWS01',
  SVDDGMMAPROBADORECREOWS01 = 'SVDDGMMAPROBADORECREOWS01',
  SVDDGMMTITULOSRECREOWS01 = 'SVDDGMMTITULOSRECREOWS01',
  SVDDGMMTITULOSPROFESIONALESWS01 = 'SVDDGMMTITULOSPROFESIONALESWS01',
  SVDDGMMPROPIEDADESACTUALWS01 = 'SVDDGMMPROPIEDADESACTUALWS01',
  SVDDGMMPROPIEDADESWS01 = 'SVDDGMMPROPIEDADESWS01',
  SVDDGMMCERTIFICADOSPROFESIONALESWS01 = 'SVDDGMMCERTIFICADOSPROFESIONALESWS01',
  SVDDGMMBUQUESWS01 = 'SVDDGMMBUQUESWS01',
  SVDDGMMBUQUESAMPLIADOWS01 = 'SVDDGMMBUQUESAMPLIADOWS01',
  SVDDGMMCONSULTAMMSIWS01 = 'SVDDGMMCONSULTAMMSIWS01',
  SVDDGMMMOTOSNAUTICASWS01 = 'SVDDGMMMOTOSNAUTICASWS01',
  SVDDGOJDESCCOMPLWS01 = 'SVDDGOJDESCCOMPLWS01',
  SVDDGOJDESCPARCIALWS01 = 'SVDDGOJDESCPARCIALWS01',
  SVDDGOJDESCULTIMAWS01 = 'SVDDGOJDESCULTIMAWS01',
  SVDDGOJALTAWS01 = 'SVDDGOJALTAWS01',
  SVDDGOJBAJAWS01 = 'SVDDGOJBAJAWS01',
  SVDDGOJMODIFWS01 = 'SVDDGOJMODIFWS01',
  SVDDGOJCONFDESCARGAWS01 = 'SVDDGOJCONFDESCARGAWS01',
  SVDDGOJESTADOWS01 = 'SVDDGOJESTADOWS01',
  SVDDGPCIWS02 = 'SVDDGPCIWS02',
  SVDDGPVIWS02 = 'SVDDGPVIWS02',
  SVDDGPTRAMITESRESIDENCIAWS01 = 'SVDDGPTRAMITESRESIDENCIAWS01',
  SVDDGPRESIDENCIALEGALDOCWS01 = 'SVDDGPRESIDENCIALEGALDOCWS01',
  SVDDGPRESIDENCIALEGALFILIACIONWS01 = 'SVDDGPRESIDENCIALEGALFILIACIONWS01',
  SVDDGPIDENTIDADNIEAMPLIADOWS01 = 'SVDDGPIDENTIDADNIEAMPLIADOWS01',
  DGSFP0002 = 'DGSFP0002',
  DGSFP0001 = 'DGSFP0001',
  DGSFP0003 = 'DGSFP0003',
  DGSFP0005 = 'DGSFP0005',
  SVDDGTVEHICULODATOSWS01 = 'SVDDGTVEHICULODATOSWS01',
  SVDDGTVEHICULODANOSVIAWS01 = 'SVDDGTVEHICULODANOSVIAWS01',
  SVDDGTVEHICULOSANCWS01 = 'SVDDGTVEHICULOSANCWS01',
  SVDDGTVEHICULOHISTWS01 = 'SVDDGTVEHICULOHISTWS01',
  SVDDGTCONDUCTORPERMISOWS01 = 'SVDDGTCONDUCTORPERMISOWS01',
  SVDDGTCONDUCTORSANCWS01 = 'SVDDGTCONDUCTORSANCWS01',
  SVDDGTTARJETAAMBIENTALWS01 = 'SVDDGTTARJETAAMBIENTALWS01',
  SVDDGTEUCARISWS01 = 'SVDDGTEUCARISWS01',
  SVDDGTVEHICULOIVTMWS01 = 'SVDDGTVEHICULOIVTMWS01',
  SVDDGTVERIFICATITULARVEHICULOWS01 = 'SVDDGTVERIFICATITULARVEHICULOWS01',
  SVDDGTHISTORIALDOMICILIOPROPIETARIOWS01 = 'SVDDGTHISTORIALDOMICILIOPROPIETARIOWS01',
  SVDDGTHISTORIALDOMICILIOVEHICULOWS01 = 'SVDDGTHISTORIALDOMICILIOVEHICULOWS01',
  SVDDGTVEHICULOCAMARASWS01 = 'SVDDGTVEHICULOCAMARASWS01',
  SVDBECAWS01 = 'SVDBECAWS01',
  SVDLSTTNUWS01 = 'SVDLSTTNUWS01',
  SVDTNUWS03 = 'SVDTNUWS03',
  SVDLSTTUWS01 = 'SVDLSTTUWS01',
  SVDTUWS03 = 'SVDTUWS03',
  SVDVTUWS01 = 'SVDVTUWS01',
  SVDVTNUWS01 = 'SVDVTNUWS01',
  SVDEDURJCUCENTROSUNIVWS01 = 'SVDEDURJCUCENTROSUNIVWS01',
  SVDEDURJCUDETALLETITUNIVWS01 = 'SVDEDURJCUDETALLETITUNIVWS01',
  SVDEDURJCUPROFREGUWS01 = 'SVDEDURJCUPROFREGUWS01',
  SVDEDURJCUTITUNIVWS01 = 'SVDEDURJCUTITUNIVWS01',
  SVDEDURJCUUNIVWS01 = 'SVDEDURJCUUNIVWS01',
  SVDEELLCONVIVENCIAWS01 = 'SVDEELLCONVIVENCIAWS01',
  SVDREELLEXTFECHAWS01 = 'SVDREELLEXTFECHAWS01',
  SVDIGAEINHABILITACIONWS01 = 'SVDIGAEINHABILITACIONWS01',
  SVDIGAECONCESIONWS01 = 'SVDIGAECONCESIONWS01',
  SVDIGAEMINIMISWS01 = 'SVDIGAEMINIMISWS01',
  SVDIGAEPCPINFOPWS01 = 'SVDIGAEPCPINFOPWS01',
  SVDIGAECORRIENTEPAGOPRESTWS01 = 'SVDIGAECORRIENTEPAGOPRESTWS01',
  SVDIGAECORRIENTEPAGOSUBWS01 = 'SVDIGAECORRIENTEPAGOSUBWS01',
  SVDIGAEAYUDASESTADOWS01 = 'SVDIGAEAYUDASESTADOWS01',
  SVDIGAECONCESIONESAMPLIADOWS01 = 'SVDIGAECONCESIONESAMPLIADOWS01',
  SVDIGAEMINIMISAMPLIADOWS01 = 'SVDIGAEMINIMISAMPLIADOWS01',
  SVDCDEPENWS01 = 'SVDCDEPENWS01',
  SVDRWS01 = 'SVDRWS01',
  SVDREXTFECHAWS01 = 'SVDREXTFECHAWS01',
  SVDINEHISTORICOMUNICIPIOSWS01 = 'SVDINEHISTORICOMUNICIPIOSWS01',
  SVDSECOPA01WS01 = 'SVDSECOPA01WS01',
  SVDINESECOPAHISTRESIDENCIACONVWS01 = 'SVDINESECOPAHISTRESIDENCIACONVWS01',
  SVDINESECOPACONVIVENCIAACTUALWS01 = 'SVDINESECOPACONVIVENCIAACTUALWS01',
  SVDINESECOPAHISTORICOMUNICIPIOSWS01 = 'SVDINESECOPAHISTORICOMUNICIPIOSWS01',
  SVDINECONVIVENCIAACTUALWS01 = 'SVDINECONVIVENCIAACTUALWS01',
  SVDINEHISTRESIDENCIACONVWS01 = 'SVDINEHISTRESIDENCIACONVWS01',
  Q2827002CINSS001 = 'Q2827002CINSS001',
  Q2827002CINSS002 = 'Q2827002CINSS002',
  SVDINSSTSDPRESTACIONESWS01 = 'SVDINSSTSDPRESTACIONESWS01',
  SVDINSSTSDINTEGRANTESIMVRISWS01 = 'SVDINSSTSDINTEGRANTESIMVRISWS01',
  SVDINSSTSDPAGOSWS01 = 'SVDINSSTSDPAGOSWS01',
  SVDINSSSSDXDAWS01 = 'SVDINSSSSDXDAWS01',
  SVDINSSSSDXIMWS01 = 'SVDINSSSSDXIMWS01',
  SVDINSSSSDXEXWS01 = 'SVDINSSSSDXEXWS01',
  SVDIVTWS01 = 'SVDIVTWS01',
  SVDIVTMWS01 = 'SVDIVTMWS01',
  SVDMIRASILOWS01 = 'SVDMIRASILOWS01',
  SVDMIRASOCIACIONESWS01 = 'SVDMIRASOCIACIONESWS01',
  SVDRRCCNACIMIENTOWS01 = 'SVDRRCCNACIMIENTOWS01',
  SVDRRCCMATRIMONIOWS01 = 'SVDRRCCMATRIMONIOWS01',
  SVDRRCCDEFUNCIONSWS01 = 'SVDRRCCDEFUNCIONSWS01',
  SVDDEFMAWS01 = 'SVDDEFMAWS01',
  SVDRRCCCERTIFICADONACIMIENTOWS01 = 'SVDRRCCCERTIFICADONACIMIENTOWS01',
  SVDRRCCCERTIFICADOMATRIMONIOWS01 = 'SVDRRCCCERTIFICADOMATRIMONIOWS01',
  SVDRRCCCERTIFICADODEFUNCIONWS01 = 'SVDRRCCCERTIFICADODEFUNCIONWS01',
  SVDDELSEXWS01 = 'SVDDELSEXWS01',
  SVDDELSEXCDIWS01 = 'SVDDELSEXCDIWS01',
  SVDCAPWS01 = 'SVDCAPWS01',
  SVDCAPCDIWS01 = 'SVDCAPCDIWS01',
  SVDAPOSTILLASOLICITARWS01 = 'SVDAPOSTILLASOLICITARWS01',
  SVDAPOSTILLASOLICITARCSVWS01 = 'SVDAPOSTILLASOLICITARCSVWS01',
  SVDAPOSTILLAPAISESHAYAWS01 = 'SVDAPOSTILLAPAISESHAYAWS01',
  SVDAPOSTILLAESTADOWS01 = 'SVDAPOSTILLAESTADOWS01',
  SVDAPOSTILLAOBTENERWS01 = 'SVDAPOSTILLAOBTENERWS01',
  SVDAPOSTILLAANULARWS01 = 'SVDAPOSTILLAANULARWS01',
  SVDJUSTICIAINHABPERIODOWS01 = 'SVDJUSTICIAINHABPERIODOWS01',
  SVDJUSTICIAINHABFECHAWS01 = 'SVDJUSTICIAINHABFECHAWS01',
  SVDJUSTICIAINHABEMPLEOPUBDOCUMENTACIONWS01 = 'SVDJUSTICIAINHABEMPLEOPUBDOCUMENTACIONWS01',
  SVDJUSTICIAINHABEMPLEOPUBWS01 = 'SVDJUSTICIAINHABEMPLEOPUBWS01',
  SVDJUSTICIAINHABANIMALESDOCUMENTACIONWS01 = 'SVDJUSTICIAINHABANIMALESDOCUMENTACIONWS01',
  SVDJUSTICIAINHABANIMALESWS01 = 'SVDJUSTICIAINHABANIMALESWS01',
  SVDJUSTICIAANTECEDENTESENTIDADWS01 = 'SVDJUSTICIAANTECEDENTESENTIDADWS01',
  SVDJUSTICIAANTECEDENTESSEXUALESENTIDADWS01 = 'SVDJUSTICIAANTECEDENTESSEXUALESENTIDADWS01 ',
  SVDSCDWS01 = 'SVDSCDWS01',
  PID_CREAR = 'SVDPIDSOLAUTWS01',
  PID_CONSULTAR = 'SVDPIDESTADOAUTWS01',
  PID_ACTUALIZAR = 'SVDPIDACTPROCWS01',
  SVDRCPINSCRITOWS01 = 'SVDRCPINSCRITOWS01',
  SVDRCPPUESTOWS01 = 'SVDRCPPUESTOWS01',
  SVDMINHAFPROLECEWS01 = 'SVDMINHAFPROLECEWS01',
  SVDUNIVERSIDADESESPECIALIDADESSANITARIASDOCWS01 = ' SVDUNIVERSIDADESESPECIALIDADESSANITARIASDOCWS01',
  SVDUNIVERSIDADESESPECIALIDADESSANITARIASFILWS01 = 'SVDUNIVERSIDADESESPECIALIDADESSANITARIASFILWS01',
  SVDFOMENTOAUTVEHICULOWS01 = 'SVDFOMENTOAUTVEHICULOWS01',
  SVDFOMENTOAUTTITULARWS01 = 'SVDFOMENTOAUTTITULARWS01',
  SVDFOMENTODATOSAUTWS01 = 'SVDFOMENTODATOSAUTWS01',
  SVDFOMENTODATOSLICENCIAWS01 = 'SVDFOMENTODATOSLICENCIAWS01',
  SVDFOMENTOTITULOSWS01 = 'SVDFOMENTOTITULOSWS01',
  SVDFOMENTOLISTADOVTCWS01 = 'SVDFOMENTOLISTADOVTCWS01',
  SVDFOMENTOVTCWS01 = 'SVDFOMENTOVTCWS01',
  SVDFOMENTOTAXIWS01 = 'SVDFOMENTOTAXIWS01',
  SVDFOMENTOLISTADOTAXIWS01 = 'SVDFOMENTOLISTADOTAXIWS01',
  SVDMUFAFIWS01 = 'SVDMUFAFIWS01',
  SVDMUFPRESTAWS01 = 'SVDMUFPRESTAWS01',
  SVDMUFABSWS01 = 'SVDMUFABSWS01',
  SVDMUFAFIXMLWS01 = 'SVDMUFAFIXMLWS01',
  SVDMUFPRESTAXMLWS01 = 'SVDMUFPRESTAXMLWS01',
  SVDMUFABSXMLWS01 = 'SVDMUFABSXMLWS01',
  HTNIAE = 'HTNIAE',
  SVDNIVRENTINAVARRAWS01 = 'SVDNIVRENTINAVARRAWS01',
  SVDNAVARRADOMFISCWS01 = 'SVDNAVARRADOMFISCWS01',
  SVDNAVARRACPAGOGENERICOWS01 = 'SVDNAVARRACPAGOGENERICOWS01',
  SVDNAVARRACPAGOTRANSPORTESWS01 = 'SVDNAVARRACPAGOTRANSPORTESWS01',
  SVDNAVARRACPAGORESIDENCIAWS01 = 'SVDNAVARRACPAGORESIDENCIAWS01',
  SVDNAVARRACBIWS01 = 'SVDNAVARRACBIWS01',
  SVDNAVARRACBTWS01 = 'SVDNAVARRACBTWS01',
  SVDNAVARRACDATWS01 = 'SVDNAVARRACDATWS01',
  SVDNAVARRACCCWS01 = 'SVDNAVARRACCCWS01',
  SVDNAVARRACSVWS01 = 'SVDNAVARRACSVWS01',
  SVDPVASCOIRPFWS01 = 'SVDPVASCOIRPFWS01',
  SVDPVASCODOMFISCWS01 = 'SVDPVASCODOMFISCWS01',
  SVDPVASCOEMPRESASRELWS01 = 'SVDPVASCOEMPRESASRELWS01',
  SVDPVASCOIAEEXTWS01 = 'SVDPVASCOIAEEXTWS01',
  SVDSMSSSIRESIDENTEWS01 = 'SVDSMSSSIRESIDENTEWS01',
  SVDSTESOROGARANTIASWS01 = 'SVDSTESOROGARANTIASWS01',
  S2800665HFTF0003 = 'S2800665HFTF0003',
  S2800665HFTF0001 = 'S2800665HFTF0001',
  S2800665HFTF0002 = 'S2800665HFTF0002',
  SVDSEPESITWS02 = 'SVDSEPESITWS02',
  SVDSEPEIACTWS02 = 'SVDSEPEIACTWS02',
  SVDSEPEIPERWS02 = 'SVDSEPEIPERWS02',
  SVDSEPEDEMWS01 = 'SVDSEPEDEMWS01',
  SVDSEPEDEMFECHAWS01 = 'SVDSEPEDEMFECHAWS01',
  SVDSEPEDATOSCONTRATOWS01 = 'SVDSEPEDATOSCONTRATOWS01',
  Q2827003ATGSS001 = 'Q2827003ATGSS001',
  Q2827003ATGSS006 = 'Q2827003ATGSS006',
  SVDTGSSVIDALABORAL5ANIOSWS01 = 'SVDTGSSVIDALABORAL5ANIOSWS01',
  SVDTGSSNAFSWS01 = 'SVDTGSSNAFSWS01',
  SVDTGSSVIDALABORALWS01 = 'SVDTGSSVIDALABORALWS01',
  SVDTGSSPLANTILLAMEDIAWS01 = 'SVDTGSSPLANTILLAMEDIAWS01',
  SVDTGSSTRAMOSAUTONOMOSWS01 = 'SVDTGSSTRAMOSAUTONOMOSWS01',
  SVDTGSSDEUDORTRIBUTARIOWS01 = 'SVDTGSSDEUDORTRIBUTARIOWS01',
  SVDTGSSNUMTRABEMPRCCCWS01 = 'SVDTGSSNUMTRABEMPRCCCWS01'
}
